import { Component, OnInit } from '@angular/core';
import { Router, ActivatedRoute, NavigationEnd } from '@angular/router';
import { AuthService } from '../../../services/auth/auth.service';
import 'rxjs/add/operator/filter';

@Component({
  selector: 'app-base-admin',
  templateUrl: './base-admin.component.html',
  styles: []
})
export class BaseAdminComponent implements OnInit {

  constructor(
    private activatedRoute: ActivatedRoute,
    private router: Router,
    private _authService: AuthService
  ) {

    this.router.events.filter(event => event instanceof NavigationEnd)
      .subscribe(event => {
        const data = this.activatedRoute.firstChild.snapshot.data;
        if (data.requireLogin && !this._authService.isLoged()) {
          this.router.navigate(['administrador']);
        }
    });
  }

  ngOnInit() {
  }

  onActivate(event) {
    window.scroll(0, 0);
  }

}



// WEBPACK FOOTER //
// /app/src/app/pages/admin/base-admin/base-admin.component.ts